module.exports = __webpack_public_path__ + "img/Broken link Icon - white.2f8046bf.svg";